module.exports = __webpack_public_path__ + "static/media/caf_footer.392ab25f.svg";